import { render, staticRenderFns } from "./WellnessChart.vue?vue&type=template&id=3c04d869&scoped=true"
import script from "./WellnessChart.vue?vue&type=script&lang=js"
export * from "./WellnessChart.vue?vue&type=script&lang=js"
import style0 from "./WellnessChart.vue?vue&type=style&index=0&id=3c04d869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04d869",
  null
  
)

export default component.exports